"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";
import { TrendingUp, ShieldCheck, Building, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const chartData = [{
  year: "2020",
  value: 120
}, {
  year: "2021",
  value: 145
}, {
  year: "2022",
  value: 190
}, {
  year: "2023",
  value: 240
}, {
  year: "2024",
  value: 310
}];
const chartConfig = {
  value: {
    label: "Valor de la finca (k€)",
    color: "var(--color-primary)"
  }
};
const investmentStats = [{
  label: "Manteniment",
  value: "Barcelona",
  description: "Serveis integrals a tota la província",
  icon: TrendingUp
}, {
  label: "Proximitat",
  value: "Girona",
  description: "Atenció ràpida i coneixement local",
  icon: ShieldCheck
}, {
  label: "Eficiència",
  value: "Tarragona",
  description: "Maquinària pròpia i equip expert",
  icon: Building
}];
export default function InvestmentPotential() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}